import { render, staticRenderFns } from "./MoveDayAttractions.vue?vue&type=template&id=22928c2e&scoped=true"
import script from "./MoveDayAttractions.vue?vue&type=script&lang=js"
export * from "./MoveDayAttractions.vue?vue&type=script&lang=js"
import style0 from "./MoveDayAttractions.vue?vue&type=style&index=0&id=22928c2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22928c2e",
  null
  
)

export default component.exports